import React from 'react'; // get the React object from the react module
import LoadableComponentLoader from '../LoadableComponentLoader/LoadableComponentLoader';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import { IMAGE_URL } from '../../../constants';

class PollWidgetWapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //inlinePollCss: true,
      displayPoll: true,
    };
  }
  componentDidMount() {
    // Check if the URL hash is '#poll'
    if (
      typeof window !== 'undefined' &&
      window?.location?.hash === '#amp_poll'
    ) {
      // Scroll to the poll widget
      const pollElement = document.getElementById('poll-widget');
      if (pollElement) {
        pollElement.scrollIntoView({ behavior: 'smooth' });
        // Remove the '#amp_poll' hash from the URL without reloading the page
        window.history.pushState(
          null,
          null,
          window.location.pathname + window.location.search,
        );
      }
    }
  }

  noPollData = pollStatus => {
    this.setState({ displayPoll: pollStatus });
  };

  render() {
    const SectionList = [
      'India',
      'City',
      'Sports',
      'Life & Style',
      'Entertainment',
    ];

    return (
      <div id="poll-widget">
        {SectionList.includes(this.props?.sectionName) && (
          <InViewObserver
            inViewCallback={() => {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                category: 'poll',
                type: 'tracking_pixel',
              });
            }}
            className="tracking_pixel"
          >
            <img src={`${IMAGE_URL}25581306.cms`} alt="1x1 polls" />
          </InViewObserver>
        )}
        <LoadableComponentLoader
          loadInView
          loadableComponentName="PollWidget"
          viewMargin="500px 0px 500px 0px"
          placeHolderStyles={{
            overflow: 'hidden', // Hides any overflow content
            transition: 'height 0.3s ease', // CSS transition for height property
            minHeight: !this.state.displayPoll
              ? '0px'
              : this.props?.height || '209px', // Dynamic height based on state
          }}
          noShowpoll={this.noPollData}
          {...this.props}
        />
      </div>
    );
  }
}

export default PollWidgetWapper;
